import {onFind} from "@elements/init-modules-in-scope";
import {addClass, closest, on, removeClass, findAllIn, findIn, find, trigger} from "@elements/dom-utils";
import axios from "axios";


export function init() {
    onFind('.js-plz-select', function (baseElement) {

        let plzInput = findIn('.js-plz-select__plz', baseElement);
        let cityInput = findIn('.js-plz-select__city', baseElement);
        let countryInput = findIn('.js-plz-select__country', baseElement);
        let loadingOverlay = findIn('.js-plz-select__loading', baseElement);
        let url = baseElement.dataset.plzSelectUrl;

        on('focus', function(){
            if(plzInput.value !== ''){
                let pendingRequest = null;
                let data = {
                    plz:  plzInput.value,
                    country:  countryInput.value,
                };
                if(cityInput.value === ''){
                    loadingOverlay.removeAttribute('hidden');
                    axios({
                        method: 'GET',
                        url: url,
                        params: data,
                        headers: {'X-Requested-With': 'XMLHttpRequest'}
                    })
                        .then((res) => res.data)
                        .then(res => {
                            if (res.success) {
                                cityInput.value = res.content.city;
                                trigger('input', cityInput);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => {
                            loadingOverlay.setAttribute('hidden', 'hidden');
                        })
                }

            }
        }, cityInput);

        on('focus', function(){
            if(cityInput.value !== ''){
                let data = {
                    city:  cityInput.value,
                    country:  countryInput.value,
                };
                if(plzInput.value === ''){
                    loadingOverlay.removeAttribute('hidden');
                    axios({
                        method: 'GET',
                        url: url,
                        params: data,
                        headers: {'X-Requested-With': 'XMLHttpRequest'}
                    })
                        .then((res) => res.data)
                        .then(res => {
                            if (res.success) {
                                trigger('input', plzInput);
                                plzInput.value = res.content.plz;
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => {
                            loadingOverlay.setAttribute('hidden', 'hidden');
                        })
                }

            }
        }, plzInput);
    });
}